import React, { useState, Fragment } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";

import H2RButton from "./H2RComponents/H2RButton";
import * as cuesApi from "../api/cue";
import DisconnectedModal from "./DisconnectedModal";
import useIsElectron from "./shared/hooks/useIsElectron";

export default function Layout({
	overflow = "hidden",
	navbar = true,
	children,
	bgColor = "bg-gray-900",
}) {
	const [hideAllDropdown, setHideAllDropdown] = useState();
	let { projectId } = useParams();

	const store = useSelector((state) => state.main);
	const selectedProject = useSelector(
		(state) => state.main?.settings?.selectedProject
	);
	const themeId = useSelector(
		(state) =>
			state.main?.projects?.[selectedProject]?.theme || "h2r_base_theme"
	);

	return (
		<div
			style={{ height: "calc(var(--vh, 1vh) * 100)" }}
			className={`${bgColor} w-screen flex flex-col text-gray-100 relative
						overflow-${overflow}
		`}
		>
			<DisconnectedModal open={!store.socket_connected} />
			<header
				className={`px-4 bg-yellow-600 w-screen flex justify-between items-center h-10 z-20 md:z-50
								${navbar ? "visible" : "hidden"}
			`}
			>
				<div className="flex items-center">
					<h1 className="hidden sm:flex font-semibold whitespace-pre">
						H2R Graphics
					</h1>
					<div className="flex sm:hidden mt-1">
						<Menu />
					</div>
					<nav className="hidden sm:flex ml:0 sm:ml-4 text-xxs sm:text-sm w-60 sm:w-full overflow-auto ">
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/rundown/${selectedProject}`}
						>
							Rundown
						</NavLink>
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/theme/${projectId}/${themeId}`}
							isActive={(match, location) => {
								if (location.pathname.includes("/theme")) return true;
							}}
						>
							Theme
						</NavLink>
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/media/${selectedProject}`}
						>
							Media
						</NavLink>
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/social/${selectedProject}`}
						>
							Social
						</NavLink>
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/score/${selectedProject}`}
						>
							Score
						</NavLink>
						<NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/variables/${selectedProject}`}
						>
							Variables
						</NavLink>
						{/* <NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/build/${selectedProject}`}
						>
							Build
						</NavLink> */}
						{/* <NavLink
							className="px-1 ml-2 hover:bg-main-500 rounded"
							activeClassName="font-bold bg-main-500"
							to={`/qanda/${selectedProject}`}
						>
							Q&A
						</NavLink> */}
					</nav>
				</div>
				<div className="relative flex z-50 gap-2">
					{/* <H2RButton
						text="Pop out"
						icon={faArrowRightFromBracket}
						size="small"
						colour="light"
						onClick={() => {
							const tab = window.location.pathname.split('/')[1]
							if (isElectron)
							console.log(window.location.pathname.split('/'))
								return socketActions.openSecondWindow(
									tab,
									store.settings?.selectedProject,
								);

							// return window.open(
							// 	`${`http://${getSelectedIpAddress()}:${
							// 		window.location.port
							// 	}/`}${controlTab.url}/${selectedProject}/`,
							// 	"_blank"
							// );
							
						}}
					/> */}
					<H2RButton
						text="Hide all"
						size="small"
						onClick={() => {
							cuesApi.hideAll(projectId);
						}}
					/>
					{hideAllDropdown && (
						<div className="absolute p-3 flex flex-col space-y-2 top-9 right-0 bg-gray-900 z-50 rounded">
							<H2RButton
								text="Hide all on Output 1"
								size="small"
								colour="dark"
								css="whitespace-pre"
								onClick={() => {
									setHideAllDropdown(false);
									cuesApi.hideAll(projectId);
								}}
							/>
							<H2RButton
								text="Hide all on Output 2"
								size="small"
								colour="dark"
								css="whitespace-pre"
								onClick={() => {
									setHideAllDropdown(false);
									cuesApi.hideAll(projectId);
								}}
							/>
							<H2RButton
								text="Hide all on Output 3"
								size="small"
								colour="dark"
								css="whitespace-pre"
								onClick={() => {
									setHideAllDropdown(false);
									cuesApi.hideAll(projectId);
								}}
							/>
							<H2RButton
								text="Hide all on Output 4"
								size="small"
								colour="dark"
								css="whitespace-pre"
								onClick={() => {
									setHideAllDropdown(false);
									cuesApi.hideAll(projectId);
								}}
							/>
						</div>
					)}
				</div>
			</header>

			<main className="flex flex-auto w-full h-0">{children}</main>
		</div>
	);
}

const solutions = [
	{
		name: "Rundown",
		href: "rundown",
	},
	{
		name: "Theme",
		href: "theme",
	},
	{
		name: "Social",
		href: "social",
	},
	{
		name: "Media",
		href: "media",
	},
	{
		name: "Score",
		href: "score",
	},
	{
		name: "Variables",
		href: "variables",
	},
	// {
	// 	name: "Q&A",
	// 	href: "qanda",
	// },
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

const Menu = () => {
	const selectedProject = useSelector(
		(state) => state.main?.settings?.selectedProject
	);
	const themeId = useSelector(
		(state) =>
			state.main?.projects?.[selectedProject]?.theme || "h2r_base_theme"
	);

	return (
		<Popover className="relative">
			{({ open }) => (
				<>
					<Popover.Button
						className={classNames(
							open ? "text-gray-900" : "text-gray-500",
							"group inline-flex items-center rounded-md bg-white text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-main-400"
						)}
					>
						<span className="text-gray-100 flex items-center justify-center">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								strokeWidth="1.5"
								stroke="currentColor"
								className="w-6 h-6"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"
								/>
							</svg>
						</span>
						{/* <ChevronDownIcon
							className={classNames(
								open ? "text-gray-600" : "text-gray-400",
								"ml-2 h-5 w-5 group-hover:text-gray-500"
							)}
							aria-hidden="true"
						/> */}
					</Popover.Button>

					<Transition
						as={Fragment}
						enter="transition ease-out duration-200"
						enterFrom="opacity-0 translate-y-1"
						enterTo="opacity-100 translate-y-0"
						leave="transition ease-in duration-150"
						leaveFrom="opacity-100 translate-y-0"
						leaveTo="opacity-0 translate-y-1"
					>
						<Popover.Panel className="absolute -left-4 z-10 mt-3 w-screen max-w-xs  transform px-2 sm:px-0 bg-gray-900">
							<div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
								<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
									{solutions.map((item) => (
										<NavLink
											key={item.name}
											to={`/${item.href}/${selectedProject}${
												item.href === "theme" ? `/${themeId}` : ""
											}`}
											className="-m-3 block rounded-md p-1 transition duration-150 ease-in-out hover:bg-gray-50"
										>
											<p className="p-2 text-base font-medium text-gray-100 bg-gray-800 hover:bg-gray-700 transition-colors rounded">
												{item.name}
											</p>
										</NavLink>
									))}
								</div>
							</div>
						</Popover.Panel>
					</Transition>
				</>
			)}
		</Popover>
	);
};
